'use client'

import { ANONYMOUS_ID_KEY } from '@nwwp/segment-analytics'

const getAnonymousIdFromCookie = () => {
  const cookie = document.cookie
    .split(';')
    .map((value) => value.trim())
    .find((value) => value.startsWith(`${ANONYMOUS_ID_KEY}=`))

  return cookie ? decodeURIComponent(cookie.slice(ANONYMOUS_ID_KEY.length + 1)) : null
}

/**
 * Retrieves the anonymous ID from local storage.
 */
export const getAnonymousId = () => {
  const anonymousId = localStorage.getItem(ANONYMOUS_ID_KEY)
  if (!anonymousId) {
    return getAnonymousIdFromCookie()
  }

  try {
    return JSON.parse(anonymousId)
  } catch {
    return anonymousId
  }
}
